"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpenseEntryType = void 0;
/** @TranslateToPython @TranslateToEnum */
var ExpenseEntryType;
(function (ExpenseEntryType) {
    ExpenseEntryType["STATED_MONTHLY_RENT"] = "STATED_MONTHLY_RENT";
})(ExpenseEntryType || (exports.ExpenseEntryType = ExpenseEntryType = {}));
